import { render, staticRenderFns } from "./IconSvg7z.vue?vue&type=template&id=05d4a44e&scoped=true&"
import script from "./IconSvg7z.vue?vue&type=script&lang=js&"
export * from "./IconSvg7z.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4a44e",
  null
  
)

export default component.exports